export default "__VITE_PUBLIC_ASSET__f394e021__"